<template>
  <div class="wrap">
    <div class="head_wrap head">
      <div class="compay_info"
         :style="{background:'url('+companyLogo+') no-repeat #29A7F4',backgroundSize:'140px',backgroundPosition:'center'}">
      </div>
      <div class="main_wrap">
        <div class=" head_right_innerbox" >
          <div class="head_nav_menu">
            <div class="head_nav_menu_item">
              <template v-for="(item,index) in menudata" >
                <span  :key="index"  :class="index == currentTabId?'on':''"  @click="changeMenu(index,item,item.children.length)">
                  {{item.menuName}}
                </span>
              
              </template>
            </div>
            
            
          </div>
          <top  @showpassword="showpassword"></top>
       </div>
      </div>
    </div>
    
    <div class="container">
 
        <menuview :proMenudata="currentTabMenu.children" ></menuview>
    
      
      <div class="main_wrap" :style="{width:bodywidth}">
        <router-view/>
        <div class="homeHeight" :style="{width:bodywidth}"></div>
      </div>
    </div>
    <passWord :visible.sync="dialogVisible"></passWord>
  </div>
</template>
<script>
import passWord from "@/components/dialog/enterprisePasswordDialog.vue";
import menuview from "@/components/menu1.vue";
import top from "@/components/top1.vue";
import api from "@/api.js";
import menulist from "@/components/menu1.js";
export default {
  name: "home",
  components: {
    menuview,
    top,
    passWord
  },
  data() {
    return {
      companyLogo1: 'https://b.yunzhidata.cn/static/img/logoDefult.png',
      companyLogo: 'https://zaoxiang.oss-cn-hangzhou.aliyuncs.com/images/2023-09-22/bafb1981f0fe2c5062b84a8ffa5edceb.png',
      dialogVisible:false,
      bodywidth: 0,
      activeIndex: '/',
      menudata: [],
      currentTabMenu: [],
      currentTabId: 0,
    };
  },
  created() {
    //本地测试新菜单，为了方便设置一个session  menu1=1，根据这个值判断页面跳转是要
     if(sessionStorage.getItem("menu1")){
       console.log('新菜单样式',sessionStorage.getItem("menu1"))
     }else{
       sessionStorage.setItem('menu1', 1)
     }
      if (sessionStorage.getItem("navMenu")) {
        this.navMenu()
        
      } else {
        this.treeList()
      }

  },
  beforeUpdate() {
      this.activeIndex = this.$route.matched[1].path
    },
  methods: {
    //获取菜单
    treeList() {
        sessionStorage.removeItem('newnavMenu')
        sessionStorage.removeItem('navMenu')
        this.axios
            .post(api.get_tree, {})
            .then(response => {
              console.log('tree---',response)
              if (response.data.code === 0) {
                sessionStorage.setItem('navMenu', JSON.stringify(response.data.tree))
                this.navMenu()
              } else {
              }
            })
            .catch(response => {
            });
      },
    navMenu() {
      
        let getItem = JSON.parse(sessionStorage.getItem("navMenu"))
        let newArray = {}
        let navMenu_list = menulist.meaulist
        
        for (let i in getItem) {
          let newArray_ = {}
          for (let j in getItem[i].childs) {
            newArray_[getItem[i].childs[j].name] = getItem[i].childs[j]
          }
          getItem[i].childs = newArray_
          newArray[getItem[i].name] = getItem[i]
        }

        sessionStorage.setItem('newnavMenu', JSON.stringify(newArray))

        
        for (let i in menulist.meaulist) {
          if (newArray[menulist.meaulist[i].menuName]) {
     
            let childs_list = []
            for (let j in menulist.meaulist[i].children) {
     
              if(newArray[menulist.meaulist[i].menuName].childs[menulist.meaulist[i].children[j].menuName]){
                childs_list.push(menulist.meaulist[i].children[j])
                
                if(menulist.meaulist[i].children[j].children && menulist.meaulist[i].children[j].children.length > 0 ){
                  let sub_children = []
                  menulist.meaulist[i].children[j].children.forEach((item,index) => {
                    
                    if(item.menuName == "客户列表" || item.menuName == "访客列表" ||  item.menuName == "营销表单" || item.menuName == "预约表单"){
                      // console.log(item)
                      sub_children.push(item)
                    }else{
                      for (let k in newArray[menulist.meaulist[i].menuName].childs[menulist.meaulist[i].children[j].menuName].childs) {
                        if(newArray[menulist.meaulist[i].menuName].childs[menulist.meaulist[i].children[j].menuName].childs[k].name === item.menuName){
                          sub_children.push(item)
                        }
                      }
                    }
                  })
                  menulist.meaulist[i].children[j].children = sub_children
                }
              }
            }
            menulist.meaulist[i].children = childs_list
            this.menudata.push(menulist.meaulist[i])
            // console.log(this.menudata)
          }
        }
        for( let ii in this.menudata){
          if(this.menudata[ii].menuName == "概况"){
            let homeChildren =
              {
                menuName: "数据概况",
                url: "/home/workSpace",
                icon: "icon-gaikuang",
              }
            this.menudata[ii].children.push(homeChildren)
          }
        }
        
        this.currentTabMenu = this.menudata[0]
      },
    showpassword() {
      this.dialogVisible = true
    },
    selectmenu(index) {
        this.$router.push({path: index});
     
      },
    changeMenu(index,data,arrLength){
      this.currentTabId = index
      this.currentTabMenu = data
      if(arrLength==0){
        this.$router.push({path: data.url});
      }
      
    },
   
  }
};
</script>
